// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Lato-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Lato-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/Cairo-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/Cairo-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/chirp.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/chirp-bold-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/fonts/chirp-heavy-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/fonts/chirp-medium-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/fonts/chirp-regular-web.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: LatoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-display: swap;
}
@font-face {
  font-family: LatoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-display: swap;
}
@font-face {
  font-family: CairoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-display: swap;
}
@font-face {
  font-family: CairoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-display: swap;
}
@font-face {
  font-family: chirp;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-display: swap;
}
@font-face {
  font-family: chirpBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-display: swap;
}
@font-face {
  font-family: chirpHeavy;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-display: swap;
}
@font-face {
  font-family: chirpMedium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-display: swap;
}
@font-face {
  font-family: chirpRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-display: swap;
}
.Notifications_scroll__eBPhb::-webkit-scrollbar {
  height: 8px;
}
.Notifications_scroll__eBPhb::-webkit-scrollbar-track {
  background-color: var(--bodyColor);
}
.Notifications_scroll__eBPhb::-webkit-scrollbar-thumb {
  background-color: var(--mainColor);
}

.Notifications_Notifications__CqWsz ul li {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.Notifications_Notifications__CqWsz .Notifications_menuItem__i9Y-X {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 367px;
  font-size: 14px;
  font-weight: bold;
  padding: 20px 2px;
}
.Notifications_Notifications__CqWsz .Notifications_notificationsCount__LoJ\\+1 {
  width: 15px;
  height: 15px;
  background: #ff0000;
  border-radius: 50%;
  position: absolute;
  top: -3px;
}
body[dir=ltr] .Notifications_Notifications__CqWsz .Notifications_notificationsCount__LoJ\\+1 {
  right: -2px;
}
body[dir=rtl] .Notifications_Notifications__CqWsz .Notifications_notificationsCount__LoJ\\+1 {
  left: -6px;
}
.Notifications_Notifications__CqWsz .Notifications_notificationsCount__LoJ\\+1 .Notifications_counter__9RxN9 {
  display: flex;
  color: var(--bgColor);
  justify-content: center;
  align-items: center;
  font-size: 8px;
  width: inherit;
  height: inherit;
}
.Notifications_Notifications__CqWsz .Notifications_isDisable__cBqNC g path {
  fill: #cbc9c9;
  stroke: #868282;
}
.Notifications_Notifications__CqWsz .Notifications_isDisable__cBqNC g line {
  stroke: #868282;
}

.Notifications_menuArrow__xdbrM {
  width: 367px;
}
.Notifications_menuArrow__xdbrM > ul {
  overflow: auto;
  width: 100%;
}
.Notifications_menuArrow__xdbrM > ul li {
  padding: 0 20px;
}
.Notifications_menuArrow__xdbrM > ul li .notifications {
  padding: 10px 0;
  width: 367px;
}
.Notifications_menuArrow__xdbrM > ul li:not(:last-of-type) .notifications {
  border-bottom: 1px solid var(--borderColor);
}
.Notifications_menuArrow__xdbrM .Notifications_MuiList-padding__9Pa7G {
  padding-top: 0;
  padding-bottom: 0;
}
.Notifications_menuArrow__xdbrM .Notifications_MuiMenuItem-root__zrO0d {
  padding-top: 0;
  padding-bottom: 0;
  max-width: 367px;
}
.Notifications_menuArrow__xdbrM .Notifications_MuiList-root__fnVPW {
  overflow-y: scroll !important;
}
.Notifications_menuArrow__xdbrM .Notifications_MuiListItem-gutters__q7boH {
  padding: 0 !important;
}
.Notifications_menuArrow__xdbrM .Notifications_MuiListItem-button__30azk {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.Notifications_menuArrow__xdbrM .Notifications_MuiMenu-list__qfpho {
  outline: 0;
  height: auto;
  height: calc(100vh - 87px);
  /* overflow: auto; */
  overflow-y: scroll;
}
.Notifications_menuArrow__xdbrM ::-webkit-scrollbar {
  display: none;
}
.Notifications_menuArrow__xdbrM:after, .Notifications_menuArrow__xdbrM:before {
  bottom: 100%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}
.Notifications_menuArrow__xdbrM:after {
  border-color: rgba(255, 255, 255, 0);
  border-bottom-color: var(--borderColor);
  border-width: 6px;
  right: 54% !important;
  margin-right: -21px;
  z-index: -1;
}
.Notifications_menuArrow__xdbrM:before {
  border-color: rgba(113, 158, 206, 0);
  border-bottom-color: #fff;
  border-width: 5px;
  right: 54% !important;
  margin-right: -20px;
  z-index: 0;
}
.Notifications_menuArrow__xdbrM .MuiTab-root {
  min-width: 61px;
  padding: 0;
}
.Notifications_menuArrow__xdbrM .MuiTab-wrapper {
  font-size: 14px !important;
  font-family: inherit;
}
body[dir=ltr] .Notifications_menuArrow__xdbrM .MuiTab-wrapper {
  font-family: "LatoBold", "CairoBold", sans-serif !important;
}
body[dir=rtl] .Notifications_menuArrow__xdbrM .MuiTab-wrapper {
  font-family: "CairoBold", "LatoBold", sans-serif !important;
}
.Notifications_menuArrow__xdbrM .MuiTab-textColorInherit {
  opacity: 1;
}
.Notifications_menuArrow__xdbrM .MuiList-padding {
  padding-top: 10px;
}

.MuiPopover-root {
  z-index: 130000 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/scss/vars.scss","webpack://./src/app/components/Notifications/Notifications.module.scss"],"names":[],"mappings":"AAKA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACJF;ADOA;EACE,qBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADQA;EACE,kBAAA;EACA,4CAAA;EACA,kBAAA;ACNF;ADSA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACPF;ADUA;EACE,uBAAA;EACA,4CAAA;EACA,kBAAA;ACRF;ADWA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACTF;ADYA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACVF;AD2HE;EACE,WAAA;ACzHJ;AD4HE;EACE,kCAAA;AC1HJ;AD6HE;EACE,kCAAA;AC3HJ;;AAhDI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAmDN;AAhDE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;AAkDJ;AAhDE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EAOA,SAAA;AA4CJ;AAlDI;EACE,WAAA;AAoDN;AAlDI;EACE,UAAA;AAoDN;AAjDI;EACE,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;AAmDN;AA9CM;EACE,aAAA;EACA,eAAA;AAgDR;AA9CM;EACE,eAAA;AAgDR;;AA3CA;EACE,YAAA;AA8CF;AA5CE;EACE,cAAA;EACA,WAAA;AA8CJ;AA5CI;EACE,eAAA;AA8CN;AA5CQ;EACE,eAAA;EACA,YAAA;AA8CV;AAzCU;EACE,2CAAA;AA2CZ;AArCE;EACE,cAAA;EACA,iBAAA;AAuCJ;AApCE;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;AAsCJ;AApCE;EACE,6BAAA;AAsCJ;AAnCE;EACE,qBAAA;AAqCJ;AAnCE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAqCJ;AAlCE;EACE,UAAA;EACA,YAAA;EACA,0BAAA;EACA,oBAAA;EACA,kBAAA;AAoCJ;AAlCE;EACE,aAAA;AAoCJ;AAjCE;EAEE,YAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,oBAAA;AAkCJ;AA/BE;EACE,oCAAA;EACA,uCAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;AAiCJ;AA9BE;EACE,oCAAA;EACA,yBAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,UAAA;AAgCJ;AA7BI;EACE,eAAA;EACA,UAAA;AA+BN;AA7BI;EDpCA,0BAAA;ECsCE,oBAAA;AA+BN;ADpEI;EACE,2DAAA;ACsEN;ADpEI;EACE,2DAAA;ACsEN;AAnCI;EACE,UAAA;AAqCN;AAnCI;EACE,iBAAA;AAqCN;;AA/BE;EACE,0BAAA;AAkCJ","sourcesContent":["//DIRECTIONS\n$ltr: 'body[dir=' ltr ']';\n$rtl: 'body[dir=' rtl ']';\n\n// FONTS\n@font-face {\n  font-family: LatoRegular;\n  src: url(../fonts/Lato-Regular.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: LatoBold;\n  src: url(../fonts/Lato-Bold.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoRegular;\n  src: url(../fonts/Cairo-Regular.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoBold;\n  src: url(../fonts/Cairo-Bold.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirp;\n  src: url(../fonts/chirp.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpBold;\n  src: url(../fonts/chirp-bold-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpHeavy;\n  src: url(../fonts/chirp-heavy-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpMedium;\n  src: url(../fonts/chirp-medium-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpRegular;\n  src: url(../fonts/chirp-regular-web.woff);\n  font-display: swap;\n}\n\n$latoRegular: 'LatoRegular', 'CairoRegular', sans-serif;\n$latoBold: 'LatoBold', 'CairoBold', sans-serif;\n$CairoRegular: 'CairoRegular', 'LatoRegular', sans-serif;\n$CairoBold: 'CairoBold', 'LatoBold', sans-serif;\n\n// COMMON STYLES\n%tablesTitle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n%pageTitle {\n  #{$ltr} & {\n    font-family: $latoBold !important;\n  }\n  #{$rtl} & {\n    font-family: $CairoBold !important;\n  }\n  font-size: 18px;\n  text-transform: uppercase;\n  position: relative;\n  margin-bottom: 40px;\n\n  &::before {\n    content: '';\n    position: absolute;\n    start: 0;\n    bottom: -10px;\n    border: 2px solid var(--secondaryColor);\n    width: 42px;\n    background-color: var(--secondaryColor);\n  }\n}\n\n%centeredHrVr {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n}\n\n// MIXINS\n@mixin fontSize($size) {\n  @if ($size == 10) {\n    font-size: 10px !important;\n  } @else if ($size == 12) {\n    font-size: 12px !important;\n  } @else if($size == 14) {\n    font-size: 14px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 16) {\n    font-size: 16px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 18) {\n    font-size: 18px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 24) {\n    font-size: 24px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if ($size == 48) {\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n    font-size: 48px !important;\n    color: #606060;\n  }\n}\n\n// Responsive Mixin\n@mixin Sm {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin Md {\n  @media (min-width: 992px) and (max-width: 1200px) {\n    @content;\n  }\n}\n\n.scroll {\n  &::-webkit-scrollbar {\n    height: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: var(--bodyColor);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--mainColor);\n  }\n}\n","@import 'app/assets/scss/vars.scss';\n\n.Notifications {\n  // color: red;\n  ul {\n    li {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n    }\n  }\n  .menuItem {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 367px;\n    font-size: 14px;\n    font-weight: bold;\n    padding: 20px 2px;\n  }\n  .notificationsCount {\n    width: 15px;\n    height: 15px;\n    background: #ff0000;\n    border-radius: 50%;\n    position: absolute;\n    #{$ltr} & {\n      right: -2px;\n    }\n    #{$rtl} & {\n      left: -6px;\n    }\n    top: -3px;\n    .counter {\n      display: flex;\n      color: var(--bgColor);\n      justify-content: center;\n      align-items: center;\n      font-size: 8px;\n      width: inherit;\n      height: inherit;\n    }\n  }\n  .isDisable {\n    g {\n      path {\n        fill: #cbc9c9;\n        stroke: #868282;\n      }\n      line {\n        stroke: #868282;\n      }\n    }\n  }\n}\n.menuArrow {\n  width: 367px;\n\n  > ul {\n    overflow: auto;\n    width: 100%;\n\n    li {\n      padding: 0 20px;\n      :global {\n        .notifications {\n          padding: 10px 0;\n          width: 367px;\n        }\n      }\n      &:not(:last-of-type) {\n        :global {\n          .notifications {\n            border-bottom: 1px solid var(--borderColor);\n          }\n        }\n      }\n    }\n  }\n  .MuiList-padding {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n\n  .MuiMenuItem-root {\n    padding-top: 0;\n    padding-bottom: 0;\n    max-width: 367px;\n  }\n  .MuiList-root {\n    overflow-y: scroll !important;\n  }\n\n  .MuiListItem-gutters {\n    padding: 0 !important;\n  }\n  .MuiListItem-button {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .MuiMenu-list {\n    outline: 0;\n    height: auto;\n    height: calc(100vh - 87px);\n    /* overflow: auto; */\n    overflow-y: scroll;\n  }\n  ::-webkit-scrollbar {\n    display: none;\n  }\n\n  &:after,\n  &:before {\n    bottom: 100%;\n    border: solid transparent;\n    content: ' ';\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n  }\n\n  &:after {\n    border-color: rgba(255, 255, 255, 0);\n    border-bottom-color: var(--borderColor);\n    border-width: 6px;\n    right: 54% !important;\n    margin-right: -21px;\n    z-index: -1;\n  }\n\n  &:before {\n    border-color: rgba(113, 158, 206, 0);\n    border-bottom-color: #fff;\n    border-width: 5px;\n    right: 54% !important;\n    margin-right: -20px;\n    z-index: 0;\n  }\n  :global {\n    .MuiTab-root {\n      min-width: 61px;\n      padding: 0;\n    }\n    .MuiTab-wrapper {\n      @include fontSize(14);\n      font-family: inherit;\n    }\n    .MuiTab-textColorInherit {\n      opacity: 1;\n    }\n    .MuiList-padding {\n      padding-top: 10px;\n    }\n  }\n}\n\n:global {\n  .MuiPopover-root {\n    z-index: 130000 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scroll": `Notifications_scroll__eBPhb`,
	"Notifications": `Notifications_Notifications__CqWsz`,
	"menuItem": `Notifications_menuItem__i9Y-X`,
	"notificationsCount": `Notifications_notificationsCount__LoJ+1`,
	"counter": `Notifications_counter__9RxN9`,
	"isDisable": `Notifications_isDisable__cBqNC`,
	"menuArrow": `Notifications_menuArrow__xdbrM`,
	"MuiList-padding": `Notifications_MuiList-padding__9Pa7G`,
	"MuiMenuItem-root": `Notifications_MuiMenuItem-root__zrO0d`,
	"MuiList-root": `Notifications_MuiList-root__fnVPW`,
	"MuiListItem-gutters": `Notifications_MuiListItem-gutters__q7boH`,
	"MuiListItem-button": `Notifications_MuiListItem-button__30azk`,
	"MuiMenu-list": `Notifications_MuiMenu-list__qfpho`
};
export default ___CSS_LOADER_EXPORT___;
